import {Service} from '../Service';
import {upsertInto} from '../../../common/helpers/db/upsertInto';
import {asRxConfigurationArray} from '../../../common/model/db/types/RxConfiguration';
import {asNumber} from '../../../common/helpers/converters/asNumber';
import {QxAction} from '../../../common/helpers/rxjs/qx/db/QxAction';
import type {ConfigurationResponse, ConfigurationSchemaResponse, SortOrder} from "../../rest-client/aat";
import {RestrictedAccess} from "../../../common/decorators/methods/RestrictedAccess";

export class ConfigurationsService extends Service {
    async deleteConfigurationsByIds(listIds: Array<number>) {
        const configurationsApi = await this.services.aat.Configurations;
        const response = await configurationsApi.deleteConfigurations({
            requestBody: listIds
        });

        this.checkStatus(response);

        this.db.configurations.modify(it => {
            return listIds.includes(asNumber(it.id)) ? QxAction.DELETE : QxAction.NOTHING;
        });
    }

    @RestrictedAccess(['AA'])
    async getConfigurations(sortBy?: string, sortOrder?: SortOrder): Promise<string[]> {
        const configurationsApi = await this.services.aat.Configurations;
        const configurations = await configurationsApi.getConfigurations({sortBy, sortOrder});

        this.checkStatus(configurations);

        const rxConfigurations = asRxConfigurationArray(configurations.configurations);

        await upsertInto(this.db.configurations, rxConfigurations);

        return rxConfigurations.map(it => it.id);
    }

    async createConfiguration(redappName: string, configurationName: string, value: string, description: string, forceSave?: boolean): Promise<ConfigurationResponse> {
        const configurationsApi = await this.services.aat.Configurations;

        const configuration = await configurationsApi.createConfiguration({
            createConfigurationRequest: {
                redappName,
                configurationName,
                value,
                description,
                forceSave
            }
        });

        this.checkStatus(configuration);

        return configuration;
    }

    async getSchema(redAppName: string): Promise<string> {
        const configurationsApi = await this.services.aat.Configurations;


        const response : ConfigurationSchemaResponse = await configurationsApi.getConfigurationSchema({
            redAppName
        });

        return response.schema;
    }

    async updateConfiguration(id: number, configurationName: string, value: string, description: string, forceSave?: boolean): Promise<ConfigurationResponse> {
        const configurationsApi = await this.services.aat.Configurations;

        const configuration = await configurationsApi.updateConfiguration({
            id,
            updateConfigurationRequest: {
                configurationName,
                value,
                description,
                forceSave
            }
        });

        this.checkStatus(configuration);
        return configuration;
    }
}